import appConfig from '../../../config/appConfig';

const purchaseUnitConfig = {
  apiUrl: appConfig.apiUrl + 'items/'
};

export default purchaseUnitConfig;



// WEBPACK FOOTER //
// ./src/components/purchaseunits/config/purchaseUnitConfig.js